import { TableUnstyled } from 'Components/Table/unstyled'

import styled from 'styled-components'

export const Table = styled(TableUnstyled)`
  width: 100%;
`

export * from './Tr'
export * from './Th'
export * from './Td'
